import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { translateErrorMessage } from '../../../utils/language.utils';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss',
  standalone: false,
})
export class VerifyComponent implements OnInit, OnDestroy {
  public isConfirming = false;
  public confirmationMessage = '';
  public errorMessage = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  private routeSubscription: Subscription;

  public ngOnInit() {
    // Get token from the URL query parameters
    this.routeSubscription = this.activatedRoute.queryParams.subscribe(
      params => {
        const token = params['token'];
        if (token) {
          this.isConfirming = true;
          this.confirmEmail(token);
        }
      }
    );
  }

  private confirmEmail(token: string) {
    this.authService
      .verifyEmail(token)
      .then(() => {
        this.router.navigate(['/login'], {
          queryParams: { verified: 'true' },
        });
      })
      .catch(error => {
        this.errorMessage = translateErrorMessage(error.message);
        console.error('Verification error:', error);
      });
  }

  public toLogin() {
    this.router.navigate(['/login'], {
      queryParams: { verified: 'true' },
    });
  }

  public ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
